(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.PowerOfZero",
            {
                url: "/PowerOfZero",
                component: "poz",
                PageTitle: "Power of Zero",
                requiredPermissions: "PowerOfZeroPlus:View",
                resolve: {
                    states: ["states", function (states) {
                        return states;
                    }],
                    purchased: ["purchaseApi", "userApi", function (purchaseApi, userApi) {
                        var o = null;
                        return userApi.getLoggedInUser().then(function (user) {
                            return purchaseApi.getUserOrders(user.Id).then(function (orders) {                                  
                                ng.forEach(orders, function (order) {
                                    if (order.MarketingStrategy === "PowerOfZeroPlus") {
                                        //o = order;
                                        var d = new Date(order.CompletedDate);
                                        var n = d.toLocaleDateString();
                                        order.PurchaseDate = n;     

                                        purchaseApi.getMarketingStrategyOfOrder(order.Id).then(function (strategy) {
                                            if (strategy.DocusignUrl != null)
                                                order.DocusignUrl = strategy.DocusignUrl;

                                            if (strategy.Image != null)
                                                order.Image = strategy.Image;                                            
                                        });
                                        o = order;       
                                    }
                                });                                                                                 
                                return o;                               
                            });
                        });
                    }]
                }
            });
        }
    ]);

    app.component("poz",
        {
            templateUrl: "App/Resources/PowerOfZero/poz.html",
            controller: pozCtrl,
            bindings: {
                states: "<",
                purchased: "<"
            }
        });

    pozCtrl.$inject = ["ssoApi", "eligibilityFormApi", "eligibilityFormDialog", "surveys", "permissionService", "purchaseApi", "$mdDialog", "userApi", "$interval", "externalLoading", "amplitudeService", "$cookies"];
    function pozCtrl(ssoApi, eligibilityFormApi, eligibilityFormDialog, surveys, permissionService, purchaseApi, $mdDialog, userApi, $interval, externalLoading, amplitudeService, $cookies) {
        var $ctrl = this;
        window.p = this;
        $ctrl.intervals = [];
       

        $ctrl.verifyPurchased = function () {
            $ctrl.purchased = null;
            var o = null;
            return userApi.getLoggedInUser().then(function (user) {
                return purchaseApi.getUserOrders(user.Id).then(function (orders) {
                    ng.forEach(orders, function (order) {
                        if (order.MarketingStrategy === "PowerOfZeroPlus") {

                            var d = new Date(order.CompletedDate);
                            var n = d.toLocaleDateString();
                            order.PurchaseDate = n;

                            purchaseApi.getMarketingStrategyOfOrder(order.Id).then(function (strategy) {
                                if (strategy.DocusignUrl !== null)
                                    order.DocusignUrl = strategy.DocusignUrl;
                                if (strategy.Image !== null)
                                    order.Image = strategy.Image;
                            });
                            o = order;
                        }
                    });

                    if (o != null) {
                        ng.forEach($ctrl.intervals, function (interval) {
                            $interval.cancel(interval);
                        });
                        $ctrl.purchased = o;
                    }
                });
            });
        };

        $ctrl.verifyPurchased();            

        $ctrl.openExternalLoginLink = function () {
            window.open("https://www.thepowerofzeropercent.com/login");
        };

        $ctrl.openExternalInterestForm = function () {           
            window.open("https://engage.figmarketing.com/acton/fs/blocks/showLandingPage/a/39120/p/p-003c/t/page/fm/0");
        };

        $ctrl.openPurchaseDialog = function ($event) {

            var alert = $mdDialog.confirm({
                clickOutsideToClose: true,
                //title: 'This is an alert title',
                textContent: 'Have you ensured that your are approved for a territory?',
                ariaLabel: 'Alert Dialog',
                ok: 'Yes',
                cancel: 'Cancel',
                targetEvent: $event,
                multiple: true
            });

            $mdDialog.show(alert).then(function () {
                $mdDialog.show(
                    {
                        bindToController: true,
                        controllerAs: "$ctrl",
                        controller: dialogCtrl,
                        templateUrl: "App/Resources/PurchasePage/template.html",
                        parent: ng.element(document.body),
                        targetEvent: $event,
                        clickOutsideToClose: false,
                        locals: {
                            purchased: false,
                            orders: purchaseApi.getAllOrders(),
                            title: "Power of Zero Plus",
                            purchaseOptions: [{ Description: "Power of Zero Plus - One Time Payment", Amount: 5000, IsRecurringPayment: false }],
                            disclaimer: "NOTE: Please ensure that you have been approved for a territory prior to purchasing",
                            termsLink: "https://www.figmarketing.com/Documents/Terms_of_Use.pdf",
                            marketingDollars: purchaseApi.getMarketingDollars().then(function (response) {
                                return response.MarketingDollarsTotal;
                            }).catch(ng.noop)
                        }
                    }).then(function (paymentAmount) {
                        if (paymentAmount > 0) {
                            //TODO: AP - Lets come up with a better way to verify the purchase after paytrace executed

                            $ctrl.intervals.push(
                                $interval(function () {
                                    $ctrl.verifyPurchased();
                                }, 3000)
                            );
                        }
                        else $ctrl.verifyPurchased();
                    });
            }).catch(function () {
                return;
            });            
        };

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };        
    }

    dialogCtrl.$inject = ["$mdDialog", "purchaseApi", "$window"];
    function dialogCtrl($mdDialog, purchaseApi, $window) {
        var $ctrl = this;      

        ng.extend($ctrl,
            {
                close: close,
                cancel: cancel,
                purchase: purchase,
                getPaymentAmount: getPaymentAmount,
                setup: setup
            });

        function setup() {            
            $ctrl.selectedPurchaseOption = 0;
            $ctrl.paymentAmount = $ctrl.purchaseOptions[0].Amount;
            $ctrl.marketingDollarsToUse = 0;
        }

        $ctrl.setup();

        function getPaymentAmount() {
            if ($ctrl.marketingDollarsToUse > $ctrl.marketingDollars) {
                $ctrl.marketingDollarsToUse = $ctrl.marketingDollars;
            }
            if ($ctrl.marketingDollarsToUse > $ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].Amount) {
                $ctrl.marketingDollarsToUse = $ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].Amount;
            }

            if ($ctrl.marketingDollarsToUse == null || $ctrl.marketingDollarsToUse < 0) {
                $ctrl.marketingDollarsToUse = 0;
            }

            $ctrl.paymentAmount = $ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].Amount - $ctrl.marketingDollarsToUse;
        }  

        function purchase(model) {
            $ctrl.submittingOrder = true;
            var order = { Description: model.Description };
            order.PaymentAmount = $ctrl.paymentAmount;
            order.MarketingDollarsUsed = $ctrl.marketingDollarsToUse;
            order.MarketingStrategy = "PowerOfZeroPlus";
            order.Total = $ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].Amount;
            if ($ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].IsRecurringPayment)
                order.Frequency = 3;
            else
                order.Frequency = 0;

            //need to identify parameters
            return purchaseApi.purchase(order)
                .then(function (response) {
                    
                    $ctrl.submittingOrder = false;
                    close($ctrl.paymentAmount);

                    if ($ctrl.paymentAmount > 0) {                     
                        $window.open(response, "_blank");
                        //$window.location.href = "/";       
                    }                  
                });
        }

        function close(paymentAmount) {
            $mdDialog.hide(paymentAmount);
        }

        function cancel() {
            $mdDialog.cancel();
        }
    };
})(window.app, window.angular); // jshint ignore:line